export const editorScrollContainerClassName = 'owaMailComposeEditorScrollContainer';
export const editorScrollContainerSelector: string = `.${editorScrollContainerClassName}`;
